import { Helmet } from 'react-helmet-async';

/**
 * SEO — page-level <title>, meta description, canonical, robots, OG/Twitter overrides.
 *
 * Purely a <head> component: no UI impact.
 * Defaults live in public/index.html; per-page usage overrides only what differs.
 */
export default function SEO({
  title,
  description,
  path = '/',
  robots = 'index,follow,max-image-preview:large',
}) {
  const canonical = `https://toonah.com${path}`;
  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={canonical} />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
    </Helmet>
  );
}
